module.exports = __webpack_public_path__ + "static/media/gerd-image2.4ce36e77.png";